import { BaseAPI } from '@emcd-shared/api-service'
import {
  requestErrorInterceptor,
  requestInterceptor,
  responseErrorInterceptor,
  responseInterceptor,
} from '@/packages/auth-service/api'
import { store } from '@/app/store'
import CONFIG from '@/app/config/config'

export class CustomApiService extends BaseAPI {
  constructor(app) {
    super(CONFIG.SEND_TO_EMAIL_SERVICE_URL)
    this.client.interceptors.request.use(
      requestInterceptor,
      requestErrorInterceptor
    )

    this.client.interceptors.response.use(
      responseInterceptor,
      responseErrorInterceptor(
        this.client,
        (res) => {
          store.dispatch('auth/authenticate', res)
        },
        app
      )
    )
  }
}

export default CustomApiService
